<template>
  <div class="min-h-screen bg-gray-50">
    <InsightsNavbar />

    <!-- Loading State -->
    <div v-if="loading" class="flex items-center justify-center py-32">
      <div
        class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-purple"
      ></div>
    </div>

    <!-- Actual Content -->
    <router-view v-else />
  </div>
</template>

<script lang="ts">
import { defineComponent, watch } from "vue";
import InsightsNavbar from "@/components/insights/InsightsNavbar.vue";
import { useEnterprisePlan } from "@/composables/useEnterprisePlan";
import { useUserStore } from "@/stores/user";

export default defineComponent({
  name: "InsightsLayout",
  components: {
    InsightsNavbar,
  },
  setup() {
    const userStore = useUserStore();
    const { isEnterprise, loading } = useEnterprisePlan();

    watch(
      [() => isEnterprise.value, () => loading.value],
      ([enterprise, isLoading]) => {
        if (!isLoading) {
          userStore.setHasEnterprisePlan(enterprise);
        }
      },
      { immediate: true }
    );

    return {
      isEnterprise,
      loading,
    };
  },
});
</script>
